import { db, storage } from "../../../firebase/firebase-config";

export const RESOURCE_CATEGORIES = [
  { key: "presentacion", label: "Presentación" },
  { key: "logos", label: "Logos" },
  { key: "tipografias", label: "Tipografías" },
  { key: "flyers", label: "Flyers" },
  { key: "pdfs", label: "PDF's" },
  { key: "videos", label: "Videos" },
];

export const getResourceCategory = async (categoryKey) => {
  const snap = await db
    .collection("resources")
    .doc(categoryKey)
    .collection("items")
    .orderBy("createdAt", "desc")
    .get();
  return snap.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
};

export const addResourceItem = async (categoryKey, data, coverFile) => {
  const docRef = db
    .collection("resources")
    .doc(categoryKey)
    .collection("items")
    .doc();

  let coverImageUrl = "";
  if (coverFile) {
    const safeName = coverFile.name.replace(/[^\w.-]/g, "_");
    const ref = storage
      .ref()
      .child(`resources/${categoryKey}/covers/${docRef.id}_${safeName}`);
    await ref.put(coverFile);
    coverImageUrl = await ref.getDownloadURL();
  }

  await docRef.set({
    name: data.name || "",
    driveUrl: data.driveUrl || "",
    coverImageUrl,
    createdAt: new Date().toISOString(),
  });
};

export const deleteResourceItem = async (categoryKey, itemId) => {
  await db
    .collection("resources")
    .doc(categoryKey)
    .collection("items")
    .doc(itemId)
    .delete();
};
